<template>
  <div id='Cobertura'>
      <b-container>
          <b-row>
						<h2 class="conheca-cobertura">
              A contratação é 100% online e, em poucos passos, <br />
              você conta com uma cobertura completa:
            </h2>
					</b-row>

					<b-row>
						<b-col lg=4 class="cada-cobertura cobertura-1">
							<b-row>
								<b-col lg="3" class="icone-quebra">
									<img loading="lazy" width="78" height="55" :src="iconRobbery" alt="icone quebra">
								</b-col>
								<b-col lg="9" class="descricao-quebra">
									<h3>Roubo</h3>
                  Quando você é abordado por uma pessoa mal-intencionada que usa de violência ou ameaça.
								</b-col>
							</b-row>

							<b-row>
								<b-col lg="3" class="icone-quebra">
									<img loading="lazy" width="65" height="71" :src="iconTheft" alt="icone liquido">
								</b-col>
								<b-col lg="9" class="descricao-quebra">
									<h3>Furto</h3>
                  Com ou sem vestígios do crime, a cobertura vale para furtos simples* ou qualificados. A Ciclic é uma das poucas que faz isso.
								</b-col>
							</b-row>

							<b-row>
								<b-col lg="3" class="icone-quebra">
									<img width="40" height="71" loading="lazy" :src="iconBroken" alt="icone roubo">
								</b-col>
								<b-col lg="9" class="descricao-quebra">
									<h3>Quebra</h3>
                  Quando é ocasionada por uma queda acidental.
								</b-col>
							</b-row>
						</b-col>

						<b-col lg=4 class="celular-vector">
							<b-col>
								<img loading="lazy" width="312" height="548" src="../../assets/svg/frontal-white.svg" alt="icone quebra">
							</b-col>
						</b-col>

            <b-col lg=4 class="cada-cobertura cobertura-2">
              <b-row>
                <b-col lg="3" class="icone-quebra">
                  <img loading="lazy" width="66" height="73" :src="iconLiquid" alt="icone liquido">
                </b-col>
                <b-col lg="9" class="descricao-quebra">
                  <h3>Líquidos</h3>
                  Quando há imersão ou derramamento de água ou outra substância líquida de maneira involuntária e oxidação.
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="3" class="icone-quebra">
                  <img loading="lazy" width="60" height="61" :src="iconExterior" alt="icone exterior">
                </b-col>
                <b-col lg="9" class="descricao-quebra">
                  <h3>Internacional</h3>
                  Quando há sinistros ocorridos no exterior.
                </b-col>
              </b-row>
            </b-col>
					</b-row>
          <b-row>
            <b-col>
              <p class="cobertura__disclaimer">*Cobertura para furto simples (sem vestígios do crime) válida para contratações a partir de 01/09/2022</p>
            </b-col>
          </b-row>
      </b-container>
  </div>
</template>

<script>
import './Cobertura.css'
export default {
	name: 'Cobertura',
	computed: {
    iconExterior () {
      return require(`@/assets/svg/icon-exterior-gray.svg`)
    },
    iconLiquid () {
      return require(`@/assets/svg/icon-liquid-gray.svg`)
    },
    iconBroken () {
      return require(`@/assets/svg/icon-broken-gray.svg`)
    },
    iconTheft () {
      return require(`@/assets/svg/icon-theft-gray.svg`)
    },
    iconRobbery () {
      return require(`@/assets/svg/icon-robbery-gray.svg`)
    }
  }
}
</script>
